import ActionSheet from '../ActionSheet';
import IcRadioActive from '@/assets/share/ic_radio_active.svg?react';
import IcRadioNormal from '@/assets/share/ic_radio_normal.svg?react';
import IcArrowRight from "@/assets/common/ic_arrow_right.svg?react";
import { PermissionChoose, PermissionStatusMap } from "@/constants/share";
import MobileInputModal, { MobileInputModalRef } from '@/component/MobileInputModal';
import { useRef } from 'react';

interface LinkShareSheetProps {
  visible: boolean;
  isCompany: boolean;
  shareScope?: string;
  password: string;
  onShareScopeChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onClose?: () => void;
}

type ShareOption = {
  id: string;
  label: string;
};

const LinkShareSheet: React.FC<LinkShareSheetProps> = ({ visible, isCompany, shareScope, password, onShareScopeChange, onPasswordChange, onClose }) => {

  const shareOptions: ShareOption[] = isCompany ?
    [
      { id: PermissionChoose.Check, label: PermissionStatusMap[PermissionChoose.Check] },
      { id: PermissionChoose.Password, label: PermissionStatusMap[PermissionChoose.Password] },
      { id: PermissionChoose.StaffCheck, label: PermissionStatusMap[PermissionChoose.StaffCheck] },
      { id: PermissionChoose.StaffPassword, label: PermissionStatusMap[PermissionChoose.StaffPassword] },
    ] :
    [
      { id: PermissionChoose.Check, label: PermissionStatusMap[PermissionChoose.Check] },
      { id: PermissionChoose.Password, label: PermissionStatusMap[PermissionChoose.Password] }
    ];

  const pwdUpdateModalRef = useRef<MobileInputModalRef>(null);

  const selectShareHandle = (value: string) => {
    onShareScopeChange(value);
  }

  const inputBlur = async (newPassword: string) => {
    if (password === newPassword) return;
    console.log(newPassword);
    onPasswordChange(newPassword);
  };

  return (
    <ActionSheet
      title="链接分享"
      showReturn={true}
      visible={visible}
      onClose={onClose}
      className="h-133 bg-#F4F6F9!"
    >
      <div className="flex flex-col m-6 bg-white rd-3 p-4">
        {shareOptions.map((option, index) => (
          <div
            key={option.id}
            className={`flex items-center justify-between h-12.5 cursor-pointer ${index < shareOptions.length - 1 ? "b-0 b-solid b-b-1 b-#F4F6F9" : ""}`}
            onClick={() => selectShareHandle(option.id)}
          >
            <span className="text-#191D26  text-3.5">{option.label}</span>
            {shareScope === option.id ? (
              <IcRadioActive className="w-4 h-4" />
            ) : (
              <IcRadioNormal className="w-4 h-4" />
            )}
          </div>
        ))}
      </div>

      {/* 访问密码输入框，仅在选择需要密码的选项时显示 */}
      {(shareScope === PermissionChoose.Password || shareScope === PermissionChoose.StaffPassword) && (
        <div className="mt-4 mx-6">
          <div className="text-#626773 text-3 mb-2">访问密码</div>
          <div className="h-12.5 flex items-center justify-between bg-white rd-3 px-4 text-3.5"
            onClick={() => {
              pwdUpdateModalRef.current?.open(password);
            }}
          >
            <span className='text-#191D26'>{password}</span>
            <div className='flex items-center justify-center'>
              <span className=" text-#A1A7B2">修改</span>
              <IcArrowRight className="w-5.5 h-5.5 ml-2" />
            </div>
          </div>
        </div>
      )}

      <MobileInputModal ref={pwdUpdateModalRef} updateValue={inputBlur} title='密码' type='number' />
    </ActionSheet>
  );
};

export default LinkShareSheet;
